(() => {
  if (customElements.get('recently-viewed-products')) {
    return;
  }

  class RecentlyViewedProducts extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const currentHandle = this.dataset.currentHandle;
      const limit = parseInt(this.dataset.limit, 10) || 10;
      const stored = localStorage.getItem('lastViewedProductId');

      this.productsHandle = stored
        ? stored
            .split(',')
            .filter((handle) => handle && handle !== currentHandle)
            .slice(0, limit)
        : [];

      this.init();
    }

    init() {
      if (!this.productsHandle.length) return;

      this.classList.remove('hidden');

      Promise.all(
        this.productsHandle.map((handle) => this.fetchCard(handle)),
      ).then((cards) => {
        const wrapper = this.querySelector('[data-swiper-wrapper]');

        cards.forEach((html) => {
          if (!html) return;
          wrapper.insertAdjacentHTML('beforeend', html);
        });

        this.dispatchEvent(new CustomEvent('slider:init', { bubbles: true }));
      });
    }

    fetchCard(handle) {
      return fetch(`/products/${handle}?view=card`)
        .then((response) => {
          let responsePath = '';
          try {
            responsePath = new URL(response.url).pathname;
          } catch (e) {
            responsePath = '';
          }

          if (response.ok && responsePath.endsWith(`/products/${handle}`)) {
            return response.text();
          }

          this.forgetHandle(handle);
          return '';
        })
        .catch(() => '');
    }

    forgetHandle(handle) {
      const stored = localStorage.getItem('lastViewedProductId');
      if (!stored) return;

      const handles = stored.split(',').filter((h) => h && h !== handle);
      localStorage.setItem('lastViewedProductId', handles.join(','));
    }
  }

  customElements.define('recently-viewed-products', RecentlyViewedProducts);
})();
